import React from "react";
import styled from "styled-components";
import SideNav from "./sidenav";

// Main layout styles
// Control all common paddings, margins, etc. here
const MainLayoutContainer = styled.div`
  width: auto;
  height: auto;
  position: relative;
`;

const SideNavContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;

  & main {
    overflow: auto;
    flex: 1;
    height: 100vh;
    background-color: var(--sumi-app-background);
  }
`;

interface MainLayoutProps {
  children: React.ReactNode;
  isProtected?: boolean;
}

export const MainLayout = ({ children, isProtected }: MainLayoutProps) => {
  return (
    <MainLayoutContainer className="main-layout-container">
      <SideNavContainer>
        {isProtected && <SideNav />}
        <main>{children}</main>
      </SideNavContainer>
    </MainLayoutContainer>
  );
};
